module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video"
  }, [(_vm.audio) ? _c('div', {
    staticClass: "audioInfo"
  }, [_c('div', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (!_vm.playing) ? _c('div', [_vm._v("点击开始播放")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.audio) ? _c('audio', {
    ref: "audio",
    attrs: {
      "src": _vm.src
    },
    on: {
      "play": _vm.onPlay,
      "pause": _vm.onPause,
      "ended": _vm.onEnd,
      "timeupdate": _vm.onTimeUpdate,
      "waiting": _vm.onWaiting,
      "loadedmetadata": _vm.onloadedmetadata
    }
  }) : _c('video', {
    ref: "video",
    attrs: {
      "src": _vm.src,
      "poster": "static/poster-1.gif",
      "x5-playsinline": "",
      "x-webkit-airplay": "",
      "webkit-playsinline": "",
      "playsinline": ""
    },
    on: {
      "play": _vm.onPlay,
      "pause": _vm.onPause,
      "ended": _vm.onEnd,
      "timeupdate": _vm.onTimeUpdate,
      "waiting": _vm.onWaiting,
      "loadedmetadata": _vm.onloadedmetadata
    }
  }), _vm._v(" "), (!_vm.playing || _vm.waiting) ? _c('div', {
    staticClass: "mask",
    on: {
      "click": _vm.toPlay
    }
  }, [(_vm.waiting) ? _c('mt-spinner') : _c('i', {
    staticClass: "music icon icon-play-o",
    attrs: {
      "href": "javascript:;"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.first) ? _c('div', {
    staticClass: "control"
  }, [(_vm.playing) ? _c('a', {
    staticClass: "icon icon-pause",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.toPause
    }
  }) : _c('a', {
    staticClass: "icon icon-play1",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.toPlay
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("secondTime")(_vm.currentTime)))]), _vm._v(" "), _c('a', {
    ref: "track",
    staticClass: "track",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('a', {
    staticClass: "thumb",
    style: (_vm.style),
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "touchstart": _vm.onTouchStart,
      "touchmove": _vm.onTouchMove,
      "touchend": _vm.onTouchEnd
    }
  }, [_c('span')])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("secondTime")(_vm.duration)))]), _vm._v(" "), (!_vm.audio) ? _c('a', {
    staticClass: "icon icon-fullscreen",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.toFullScreen
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.debug) ? _c('div', {
    staticClass: "debug"
  }, [_vm._v(_vm._s(_vm.fps))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f79440f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/movie/MovieVideo.vue
// module id = 309
// module chunks = 0